export const WifiPoints: any[] = [
  {
    location: {
      address: 'Plaza 14 de Septiembre',
      coords: {
        lat: '-17.393925591501862',
        lng: '-66.15702821244467'
      }
    }
  },
  {
    location: {
      address: 'Parque Ex Combatientes',
      coords: {
        lat: '-17.385290631243635',
        lng: '-66.17526056811057'
      }
    }
  },
  {
    location: {
      address: 'Parque Lincoln',
      coords: {
        lat: '-17.369465361233697',
        lng: '-66.17401760656611'
      }
    }
  },
  {
    location: {
      address: 'Parque Demetrio Canelas',
      coords: {
        lat: '-17.37941696209576',
        lng: '-66.17415842358368'
      }
    }
  },
  {
    location: {
      address: 'Parque de la cultura',
      coords: {
        lat: '-17.373369043688253',
        lng: '-66.14634729519695'
      }
    }
  },
  {
    location: {
      address: 'Parque Pio X',
      coords: {
        lat: '-17.40276868115674',
        lng: '-66.16644510205668'
      }
    }
  },
  {
    location: {
      address: 'Biblioavion',
      coords: {
        lat: '-17.419697685651276',
        lng: '-66.14059537988263'
      }
    }
  },
  {
    location: {
      address: 'Plaza Sucre',
      coords: {
        lat: '-17.39235054571837',
        lng: '-66.14802145976581'
      }
    }
  },
  {
    location: {
      address: 'Centro Oncológico',
      coords: {
        lat: '-17.388293146714503',
        lng: '-66.15034714265687'
      }
    }
  },
  {
    location: {
      address: 'Plaza de las Banderas',
      coords: {
        lat: '-17.382468599290675',
        lng: '-66.15969026522951'
      }
    }
  },
  {
    location: {
      address: 'Cristo de la Concordia',
      coords: {
        lat: '-17.384380694494702',
        lng: '-66.13506342712519'
      }
    }
  }
]

export const WifiCircleOptions = {
  color: '#47277880',
  fillColor: '#482778',
  fillOpacity: 0.1
};